/*
================================================================================
|                                                                              |
|  FILE: src/sections/ecorevivepage/ProjectCommitment.js                       |
|  PURPOSE: Project Commitment section with final message and call to action. |
|                                                                              |
================================================================================
*/
import React from 'react';

export default function ProjectCommitment() {
    return (
        <section className="py-20 bg-gradient-to-br from-green-50 via-blue-50 to-emerald-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-100 text-green-800 rounded-full text-sm font-semibold mb-6">
                        <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                        Our Commitment
                    </div>
                    <h2 className="text-5xl font-bold mb-6 text-gray-900">
                        EcoRevive is not just a project
                    </h2>
                    <p className="text-2xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
                        It's a commitment to future generations
                    </p>
                </div>

                <div className="grid lg:grid-cols-3 gap-8 mb-16">
                    <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 text-center shadow-lg border border-gray-100">
                        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                            </svg>
                        </div>
                        <h3 className="text-xl font-bold mb-3 text-gray-900">Environmental Stewardship</h3>
                        <p className="text-gray-700">Restoring degraded landscapes and ecosystems for sustainable future</p>
                    </div>

                    <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 text-center shadow-lg border border-gray-100">
                        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                        </div>
                        <h3 className="text-xl font-bold mb-3 text-gray-900">Community Empowerment</h3>
                        <p className="text-gray-700">Building resilient communities through sustainable development</p>
                    </div>

                    <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 text-center shadow-lg border border-gray-100">
                        <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <svg className="w-8 h-8 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                            </svg>
                        </div>
                        <h3 className="text-xl font-bold mb-3 text-gray-900">Innovation & Technology</h3>
                        <p className="text-gray-700">Leveraging cutting-edge solutions for environmental restoration</p>
                    </div>
                </div>

                {/* <div className="text-center">
                    <div className="inline-flex items-center gap-4 px-8 py-4 bg-white/20 backdrop-blur-sm rounded-full">
                        <span className="text-sm font-semibold">Field Inspection & Assessment Report</span>
                        <span className="text-white/60">•</span>
                        <span className="text-sm">July, 2025</span>
                    </div>
                </div> */}
            </div>
        </section>
    );
} 